import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ChevronDown, ChevronUp } from "lucide-react";

interface ExpandableReasonProps {
  text: string;
  maxLines?: number;
  className?: string;
}

export function ExpandableReason({ 
  text, 
  maxLines = 2,
  className 
}: ExpandableReasonProps) {
  const { t } = useTranslation('analysis');
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if text is long enough to need expansion
  // Rough estimate: ~60 chars per line on mobile
  const needsExpansion = text.length > maxLines * 60;

  if (!text) return null;

  return (
    <div className={cn("relative", className)}>
      <p
        className={cn(
          "text-xs text-[hsl(var(--sg7-text-muted))] leading-relaxed",
          !isExpanded && needsExpansion && "line-clamp-2"
        )}
      >
        {text}
      </p>

      {needsExpansion && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={cn(
            "mt-1 inline-flex items-center gap-1",
            "text-[10px] font-semibold uppercase tracking-wide",
            "text-[hsl(var(--sg7-gold))]",
            "hover:text-[hsl(var(--sg7-gold-glow))]",
            "transition-colors duration-200"
          )}
        >
          {isExpanded ? (
            <>
              {t('picks.viewLess')}
              <ChevronUp className="h-3 w-3" />
            </>
          ) : (
            <>
              {t('picks.viewDetails')}
              <ChevronDown className="h-3 w-3" />
            </>
          )}
        </button>
      )}
    </div>
  );
}
